// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file chat/v3/chat_prompt.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Scope } from "../../query/v3/scope_pb";
import { file_query_v3_scope } from "../../query/v3/scope_pb";
import type { RichText } from "./chat_rich_text_pb";
import { file_chat_v3_chat_rich_text } from "./chat_rich_text_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Feature } from "../../entitlements/v3/features_pb";
import { file_entitlements_v3_features } from "../../entitlements/v3/features_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_prompt.proto.
 */
export const file_chat_v3_chat_prompt: GenFile = /*@__PURE__*/
  fileDesc("ChljaGF0L3YzL2NoYXRfcHJvbXB0LnByb3RvEgdjaGF0LnYzIsgDCgZQcm9tcHQSHAoHY2hhdF9pZBgBIAEoCUILmrUYB2NoYXRfaWQSMAoPbGFuZ3VhZ2VfcmVnaW9uGAIgASgOMhcuaTE4bi52My5MYW5ndWFnZVJlZ2lvbhIuChFwYXJlbnRfbWVzc2FnZV9pZBgEIAEoCUIOmrUYCm1lc3NhZ2VfaWRIAYgBARIOCgR0ZXh0GAUgASgJSAASJgoJcmljaF90ZXh0GAYgASgLMhEuY2hhdC52My5SaWNoVGV4dEgAEiMKBXNjb3BlGAcgASgLMg8ucXVlcnkudjMuU2NvcGVIAogBARItCgVtb2RlbBgIIAEoDjIYLmVudGl0bGVtZW50cy52My5GZWF0dXJlQgSQtRgBEhYKDnJlY29yZF9zZXNzaW9uGAkgASgIEiQKCnNlc3Npb25faWQYCiABKAlCEJq1GAxzdGlkLlNlc3Npb24SJgoMd29ya3NwYWNlX2lkGAsgASgJQhCatRgMd29ya3NwYWNlX2lkEiIKCnByb2plY3RfaWQYDCABKAlCDpq1GApwcm9qZWN0X2lkQggKBnByb21wdEIUChJfcGFyZW50X21lc3NhZ2VfaWRCCAoGX3Njb3BlQldaVWdpdGh1Yi5jb20vU3Rvcnl0ZWxsLWFpL3N0b3J5dGVsbC1haS1wbGF0Zm9ybS9wa2cvZ28vZG9tYWlucy9jcC9nZW4vcGIvY2hhdC92MztjaGF0VjNiBnByb3RvMw", [file_i18n_v3_language_regions, file_query_v3_scope, file_chat_v3_chat_rich_text, file_common_v3_common, file_entitlements_v3_features]);

/**
 * @generated from message chat.v3.Prompt
 */
export type Prompt = Message<"chat.v3.Prompt"> & {
  /**
   * format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * en-US
   *
   * @generated from field: i18n.v3.LanguageRegion language_region = 2;
   */
  languageRegion: LanguageRegion;

  /**
   * The ID of the parent message. When establishing a new conversation
   * this value can be omitted, an empty string, or set to a
   * zero value such as 'message_00000000000000000000'.
   *
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: optional string parent_message_id = 4;
   */
  parentMessageId?: string;

  /**
   * @generated from oneof chat.v3.Prompt.prompt
   */
  prompt: {
    /**
     * @generated from field: string text = 5;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: chat.v3.RichText rich_text = 6;
     */
    value: RichText;
    case: "richText";
  } | { case: undefined; value?: undefined };

  /**
   * Query to obtain knowledge to satisfy the task.
   *
   * @generated from field: optional query.v3.Scope scope = 7;
   */
  scope?: Scope;

  /**
   * The model to use for the prompt.
   *
   * @generated from field: entitlements.v3.Feature model = 8;
   */
  model: Feature;

  /**
   * Whether to record the session for later playback
   *
   * @generated from field: bool record_session = 9;
   */
  recordSession: boolean;

  /**
   * @generated from field: string session_id = 10;
   */
  sessionId: string;

  /**
   * The workspace and project IDs are used to determine the the location
   * to save the chat and its messages.
   *
   * @generated from field: string workspace_id = 11;
   */
  workspaceId: string;

  /**
   * @generated from field: string project_id = 12;
   */
  projectId: string;
};

/**
 * Describes the message chat.v3.Prompt.
 * Use `create(PromptSchema)` to create a new message.
 */
export const PromptSchema: GenMessage<Prompt> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 0);

